import React from 'react';
import VideoTwo from '../elements/video/VideoTwo';
import SEO from "../common/SEO";
import HeaderOne from '../common/header/HeaderOne';
import HeaderTopNews from '../common/header/HeaderTopNews';
import FooterOne from '../common/footer/FooterOne';
import Copyright from '../common/footer/Copyright';
import ServiceThree from '../elements/service/ServiceThree';
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import Separator from "../elements/separator/Separator";
import AboutFour from '../elements/about/AboutFour';
import SlipThree from '../elements/split/SlipThree';
import BrandThree from '../elements/brand/BrandThree';
import TeamThree from '../elements/team/TeamThree';
import PricingTwo from '../elements/pricing/PricingTwo';

import {Link} from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import BlogList from "../components/blog/itemProp/BlogList";
import BlogClassicData from '../data/blog/BlogList.json';
import { BannerActivation } from "../utils/script";
import ScrollAnimation from "react-animate-on-scroll";

import Slider from "react-slick";

var BlogListData = BlogClassicData.slice(0, 3);


const BannerData1 = [
    {
        image: "/images/sate2025/satte-banner.jpg",
        title: "Connecting Travel and Tourism Professionals all around the world",
        description: "Connecting Travel and Tourism Professionals all around the world"
    }
    
]

const BannerData = [
    // {
    //     image: "./images/otm2025/1.png"
    // },
    {
        image: "/images/sate2025/1.png"
    },
    // {
    //     image: "/images/otm2025/2.png"
    // },
    {
        image: "/images/sate2025/2.png"
    },
    // {
    //     image: "/images/otm2025/3.png"
    // },
    {
        image: "/images/sate2025/3.png"
    },
    {
        image: "/images/sate2025/4.png"
    },
    {
        image: "/images/sate2025/5.png"
    },
    {
        image: "/images/sate2025/6.png"
    },
    {
        image: "/images/sate2025/7.jpeg"
    }
    
]



const Satte2025 = () => {

    var settings = {
        dots: true,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true
      };

    return (
        <>
            <SEO title="Event Conference" />

            <main className="page-wrapper">
                <HeaderOne btnStyle="btn-small btn-icon" HeaderSTyle="header-not-transparent" />

                {/* Start Slider Area  */}
                {/* <div className="slider-area slider-style-6 shape-left inheader-not-transparent height-750">
                    <div className="container">
                        <div className="align-items-center">
                           
                            <div className="shape-image">
                                <img src="./images/otm2025/OTM-banner.jpg" alt="Banner Images" />
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* End Slider Area  */}

                <Slider className="slider-area slider-style-4 slider-dot rn-slick-dot rn-slick-arrow" {...BannerActivation}>
                    {BannerData1.map((data, index) => (
                        <div key={index} className="single-slide">
                            <div className={"height-750 bg_image_new "} style={{backgroundImage: `url(${process.env.PUBLIC_URL} ${data.image})`}}>
                                <div className="container">
                                <div className="row">
                                <div className="col-lg-12">
                                <div className="inner text-center">
                                       
                                            </div>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>


                {/* Start Service Area  */}
                <div className="rn-service-area rn-section-gap-events ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    title = "South Asia's Travel and Tourism Exchange (SATTE) 2025"
                                    description = ""
                                />
                            </div>
                        </div>
                      
                    </div>
                </div>
                {/* End Service Area  */}

                <Separator />
                <div className="container" style={{paddingLeft:"10%", paddingRight:"10%"}}>
                <p style={{textAlign:"justify"}}><b>SATTE (South Asia’s Travel & Tourism Exchange)</b> is the most influential and comprehensive travel and tourism exhibition in Asia. Recognized as the leading platform for industry professionals, SATTE brings together domestic and international buyers, tourism boards, and hospitality leaders to foster business collaboration, share insights, and accelerate industry growth. Supported by the Ministry of Tourism, Government of India, along with leading travel associations, national and state tourism boards, and international tourism organizations, SATTE continues to play a pivotal role in shaping the future of travel.</p>
                <div className="col-lg-12">
                    <SectionTitle
                        textAlign = "text-center"
                        radiusRounded = ""
                        subtitle = "SATTE 2025 – A Grand Stage for the Industry"
                        title = ""
                        description = ""
                    />
                </div>
                
                <p style={{textAlign:"justify"}}>
                Scheduled to take place from February 19-21, 2025, at Yashobhoomi, New Delhi, SATTE 2025 is set to be the biggest edition yet. With over 2,000 exhibitors and an expected footfall of 40,000+ visitors, the event is designed to be a hub of innovation, knowledge-sharing, and unparalleled networking opportunities. This year, SATTE will reinforce its position as a global leader in travel exhibitions, creating an ecosystem where industry stakeholders can connect, collaborate, and explore new business possibilities.
                </p>
                
                <div className="col-lg-12">
                    <SectionTitle
                        textAlign = "text-center"
                        radiusRounded = ""
                        subtitle = "The Launch of the “+1” Campaign – A Game-Changer"
                        title = ""
                        description = ""
                    />
                    <p style={{textAlign:"justify"}}>SATTE 2025 introduces the groundbreaking “+1” campaign, a strategic initiative aimed at further elevating the event’s impact on the industry. This campaign is designed to position SATTE not just as a business exhibition but as a platform for thought leadership, industry transformation, and sustained growth. By expanding its offerings and enhancing engagement, SATTE 2025 is committed to delivering a richer and more dynamic experience for exhibitors and visitors alike.</p>
                </div>

                <div className="col-lg-12">
                    <SectionTitle
                        textAlign = "text-center"
                        radiusRounded = ""
                        subtitle = "Exclusive Events & High-Profile Partnerships"
                        title = ""
                        description = ""
                    />
                    <p style={{textAlign:"justify"}}>
                    This year’s edition will feature several exclusive events designed to maximize engagement and create lasting business relationships. The Leadership Summit will bring together global thought leaders and industry pioneers to discuss emerging trends, innovative business strategies, and the future of travel. The Golf Tournament will offer an informal networking space where professionals can connect in a relaxed environment, strengthening relationships beyond the exhibition floor. Additionally, Atithi, organized in association with SEPC (Services Export Promotion Council), will bring in over 250 international buyers, providing significant business and networking opportunities for participants.</p>
                </div>

                <div className="col-lg-12">
                    <SectionTitle
                        textAlign = "text-center"
                        radiusRounded = ""
                        subtitle = "Innovative New Initiatives at SATTE 2025"
                        title = ""
                        description = ""
                    />
                    <p style={{textAlign:"justify"}}>

                    To enhance participant engagement and provide greater value, SATTE 2025 introduces multiple new initiatives. The SATTE Awards will recognize excellence and innovation in the travel industry, honoring organizations and individuals who have made remarkable contributions to the sector. The SATTE 365 Clicks initiative ensures that the impact of the event extends beyond the three days, keeping the momentum alive throughout the year. The newly launched SATTE Podcast will provide ongoing insights and discussions on industry trends, offering valuable perspectives from experts worldwide. </p>                
                    
                    <p style={{textAlign:"justify"}}>
                    Additionally, Route 30 will serve as an exclusive networking platform for key decision-makers, fostering high-level business discussions. SATTE Connect will be a dedicated initiative to facilitate new business collaborations, while SATTE Road Shows will expand the event’s reach to various regions across India, engaging local businesses and stakeholders. Another exciting addition is Colors of SATTE, a celebration of the diversity and vibrancy of the travel industry. The Shakti Awards will honor women leaders in the sector, recognizing their contributions to tourism and hospitality. Furthermore, the SATTE Association Reach Program will strengthen partnerships with travel and tourism associations, broadening the event’s global influence.
                    </p>
                    </div>

                    <div className="col-lg-12">
                    <SectionTitle
                        textAlign = "text-center"
                        radiusRounded = ""
                        subtitle = "A Strong National & Global Presence"
                        title = ""
                        description = ""
                    />
                    <p style={{textAlign:"justify"}}>
                    SATTE 2025 is set to expand its reach like never before, covering 4,027 cities across India, including key tier-one and tier-two cities. This extensive national footprint ensures that the event remains an inclusive and accessible platform for travel professionals from all corners of the country. The participation of international buyers and exhibitors further strengthens its global presence, facilitating cross-border partnerships and business opportunities. The event’s emphasis on fostering strong industry relationships will contribute to positioning India as a central hub for global tourism and hospitality.</p>
                </div>

                <div className="col-lg-12">
                    <SectionTitle
                        textAlign = "text-center"
                        radiusRounded = ""
                        subtitle = "Insights from Industry Leaders"
                        title = ""
                        description = ""
                    />
                    <p style={{textAlign:"justify"}}>
                    Pallavi Mehra, Sr. Group Director of SATTE, emphasized the transformative impact of SATTE 2025, stating, “SATTE 2025 is set to be our most impactful edition to date. With the ‘+1’ campaign, we are focused on providing a more dynamic and valuable experience for all participants. Our goal is not just to offer a business and networking platform, but to be a place where industry leaders can explore innovative solutions, discover new growth opportunities, and build meaningful connections that will shape the future of travel. SATTE continues to evolve to stay ahead of the curve and remain the premier event for the global travel and tourism industry.”
                  </p>
                </div>

                <div className="col-lg-12">
                    <SectionTitle
                        textAlign = "text-center"
                        radiusRounded = ""
                        subtitle = "Why Attend SATTE 2025?"
                        title = ""
                        description = ""
                    />
                    <p style={{textAlign:"justify"}}>
                    For travel professionals, SATTE 2025 offers unmatched business opportunities, market insights, and networking platforms. Attendees will have access to decision-makers from leading travel agencies, airlines, hospitality brands, tourism boards, and technology providers. With a focus on innovation and industry transformation, the event is an essential platform for businesses looking to expand their market reach, build strategic alliances, and stay ahead of evolving trends.
                    </p>
                </div>

                <div className="col-lg-12">
                    <SectionTitle
                        textAlign = "text-center"
                        radiusRounded = ""
                        subtitle = "Register Now for SATTE 2025!"
                        title = ""
                        description = ""
                    />
                    <p style={{textAlign:"justify"}}>
                    Don’t miss the opportunity to be a part of the largest and most influential travel and tourism exhibition in Asia. Whether you are an exhibitor looking to showcase your offerings or a visitor eager to explore new business possibilities, SATTE 2025 is the ultimate destination to achieve your goals. Register now to gain exclusive benefits and ensure your place at the forefront of industry transformation.
                    To register as a visitor, click the button below.                    
                    </p>
                    <p style={{textAlign:"justify"}}>
                    To learn more about SATTE 2025, visit: <a href="https://www.satte.in"  target="_blank">www.satte.in</a>               
                    </p>
                    <p style={{textAlign:"justify"}}>
                    Join us at SATTE 2025, which will take place from February 19 to 21, 2025, at Yashobhoomi, New Delhi, and help shape the future of travel and tourism!
                    </p>
                </div>

                </div>


                <div className="text-center">
                <ScrollAnimation 
                animateIn="fadeInUp"
                animateOut="fadeInOut"
                animateOnce={true}>
                    <a className="btn-default btn-large round" target="_blank" href="https://visitor-registration.satte.in/exhibitor_reference_registration"><span>Register Now</span></a>
                </ScrollAnimation>
                </div>


                <Separator />
                <div className="slider-container mb--30 mt--40" >
                <Slider {...settings}>
                {BannerData.map((data, index) => (
                        <div key={index}>
                            <div className="container">
                    <div className="row row--30 align-items-center">
                    <div className="col-lg-1">
                    </div>
                    <div className="col-lg-10">
                        <div className="thumbnail">
                            <img className="w-100" src={`${data.image}`} alt="gallery" />
                        </div>
                    </div>
                    <div className="col-lg-1">
                          </div>
                    </div>
                    </div>
                        </div>
                    ))}
                </Slider>
                </div>


                <FooterOne />
                <Copyright />
            </main>

        </>
    )
}

export default Satte2025;
